module.exports = __webpack_public_path__ + "media/components/img/mola_subscriber-e45b3bebd175302e054f19ae46c6446f.png";